import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, ArrowUpRight } from 'lucide-react';

const DonateCTA = () => (
  <section id="donate" className="py-20 md:py-28 bg-cream" data-testid="home-donate-cta">
    <div className="max-w-[1300px] mx-auto px-6 lg:px-10">
      <div className="relative overflow-hidden rounded-[2.5rem] bg-mahogany text-cream px-8 py-14 md:px-16 md:py-20">
        <div className="pointer-events-none absolute -right-16 -bottom-16 w-[420px] h-[420px] opacity-10">
          <FloralPetals />
        </div>
        <div className="relative max-w-2xl">
          <div className="flex items-center gap-3 mb-5">
            <span className="w-9 h-9 rounded-full bg-cream/15 flex items-center justify-center"><Heart className="w-4 h-4 text-cream" /></span>
            <span className="uppercase tracking-[0.2em] text-cream/70 text-xs">Support Our Work</span>
          </div>
          <h2 className="font-serif-display text-4xl md:text-6xl leading-[1.05]">Give with an <span className="font-italic-display text-rose-soft">Open Heart</span></h2>
          <p className="mt-5 text-cream/85 text-base md:text-lg leading-relaxed">
            Your contribution keeps meditation, retreats and the sharing of Osho’s vision alive and
            accessible to seekers everywhere — from our library initiative to the dream of 108 ashrams worldwide.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/donate" className="pill-btn bg-cream text-mahogany hover:bg-white" data-testid="home-donate-btn">Donate Now <Heart className="w-4 h-4" /></Link>
            <Link to="/membership" className="pill-btn-outline border-cream/40 text-cream hover:bg-cream/10" data-testid="home-membership-btn">Become a Member <ArrowUpRight className="w-4 h-4" /></Link>
          </div>
        </div>
      </div>
    </div>
  </section>
);

const FloralPetals = () => (
  <svg viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg" fill="#F5C7CD">
    {Array.from({ length: 16 }).map((_, i) => (
      <ellipse key={i} cx="200" cy="90" rx="22" ry="70" transform={`rotate(${i * 22.5} 200 200)`} />
    ))}
    <circle cx="200" cy="200" r="22" fill="#EEB1BA" />
  </svg>
);

export default DonateCTA;
